// used in ADMIN
export const validateQuizContent = quizContent => {
  try {
    quizContent.hasInvalidTitle = !quizContent.title?.find(
      x => x.value?.trim()?.length
    );

    quizContent.quiz?.questionAnswers?.forEach(item => {
      item.hasInvalidQuestion = !item.question?.find(
        x => x.value?.trim()?.length
      );

      item.choices?.forEach(ch => {
        ch.hasInvalidChoice = !ch.value?.find(x => x.value?.trim()?.length);
      });

      item.hasInvalidChoices = item.choices?.some(ch => ch.hasInvalidChoice);
    });
  } catch (e) {
    console.log("quizHelper.validateQuizContent:", e.message);
  }

  return quizContent;
};

// used in EMPLOYEE
export const getRandomSubArray = (arr, length) => {
  try {
    // Validate the length parameter
    if (length <= 0 || length > arr.length) {
      length = arr.length;
    }

    // Create a copy of the original array to avoid modifying it
    const originalArray = arr.slice();

    // Validate if the array has enough unique elements
    if (new Set(originalArray).size < length) {
      throw new Error("Not enough unique elements in the array");
    }

    // Shuffle the array using Fisher-Yates algorithm
    for (let i = originalArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [originalArray[i], originalArray[j]] = [
        originalArray[j],
        originalArray[i],
      ];
    }

    // Return a subarray of the specified length with unique elements
    return originalArray.slice(0, length);
  } catch (e) {
    console.log("quizHelper.getRandomSubArray:", e.message);
  }

  return arr;
};
